import React, { useRef, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { useParams } from "react-router-dom";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import { ToolsContent } from "./components/common-components";
import { Domain } from "src/config/BartLambdaConfig";
import "../commons/common.styles.scss";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import AppArd from "src/components/fuseArdPage/ard-page";
import { useSettingsStore } from "src/stores/useSettingsStore";
import { resolveInitialPanelState } from "src/hooks/useInitialPanelState";
interface Props {
  domain: Domain;
}

export function FuseArd(props: Props) {
  const { id } = useParams();
  const { navPanelBehavior, toolsPanelBehavior } = useSettingsStore();
  const [navigationOpen, setNavigationOpen] = React.useState(
    resolveInitialPanelState(false, navPanelBehavior),
  );
  const appLayout = useRef<AppLayoutProps.Ref>(null);
  const [toolsOpen, setToolsOpen] = useState(
    resolveInitialPanelState(false, toolsPanelBehavior),
  );
  const loadPanelFn = () => {
    setToolsOpen(true);
    appLayout.current?.focusToolsClose();
  };

  const onToolsChangeFn = ({
    detail,
  }: NonCancelableCustomEvent<AppLayoutProps.ChangeDetail>) => {
    setToolsOpen(detail.open);
  };
  return (
    <AppLayout
      disableContentPaddings
      content={<AppArd key={id} domain={props.domain} />}
      navigation={<Navigation activeHref={URLS.GET_ARD} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      tools={<ToolsContent />}
      toolsOpen={toolsOpen}
      onToolsChange={onToolsChangeFn}
      ariaLabels={appLayoutAriaLabels}
    />
  );
}
